// extracted by mini-css-extract-plugin
export default {"modal":"CommodityModal_modal__cNIkY","modalBody":"CommodityModal_modalBody__Tpz9O","modalButtons":"CommodityModal_modalButtons__nwDfy","button":"CommodityModal_button__dPDV-"};